module.exports = __webpack_public_path__ + "static/media/location01.909fda4a.webp";